import { compose } from "recompose";

import cartProductAdd, {
  ICartProductAdd,
} from "../../hoc/persister/cartProductAdd/cartProductAdd";
import userProductAlertStockUpdate, {
  IUserProductAlertStockUpdate,
} from "../../hoc/persister/userProductAlertStockUpdate/userProductAlertStockUpdate";

import ProductAddButton, { IProps } from "./ProductAddButton.component";

type IInjectedProps = IUserProductAlertStockUpdate & ICartProductAdd;

type IContainerProps = Omit<IProps, keyof IInjectedProps>;

export default compose<IProps, IContainerProps>(
  userProductAlertStockUpdate,
  cartProductAdd
)(ProductAddButton);
